exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploaded-logo[data-v-0eb8f7be] {\n  display: block;\n  color: #139ada;\n  margin-top: 5px;\n  padding-right: 15px;\n}\n", ""]);

// exports
